import {
  Datagrid,
  TextField,
  // SearchInput,
  TextInput,
  SelectInput,
  useTranslate,
  FunctionField,
  ReferenceField,
} from 'react-admin'
import { ListBase } from '../../components/base'
import { DateField } from '../../components/fields'
import { COMMON_FIELDS, SERVICES_FIELDS } from '../../providers/localization/constant'

const ServicesListFilters = (): JSX.Element[] => {
  const translate = useTranslate()
  return [
    // <SearchInput
    //   key={0}
    //   source='q'
    //   alwaysOn
    //   InputLabelProps={{ shrink: true }}
    //   InputProps={{ notched: false }}
    //   placeholder={translate(`${SERVICES_FIELDS}.name`)}
    // />,
    <TextInput
      key={0}
      source='title'
      // InputLabelProps={{ shrink: true }}
      // InputProps={{ notched: false }}
      // placeholder={translate(`${PRODUCTS_COMMON_FIELDS}.prod_code.label`)}
      label={translate(`${SERVICES_FIELDS}.title`)}
    />,
    // <SelectInput
    //   key={1}
    //   label={`${COMMON_FIELDS}.published.label`}
    //   source='is_published'
    //   choices={[
    //     { id: 'true', name: `${COMMON_FIELDS}.published.choices.true` },
    //     { id: 'false', name: `${COMMON_FIELDS}.published.choices.false` },
    //   ]}
    // />,
    <SelectInput
      key={4}
      label={`${COMMON_FIELDS}.has_slug.label`}
      source='has_slug'
      choices={[
        { id: true, name: `${COMMON_FIELDS}.has_slug.choices.true` },
        { id: false, name: `${COMMON_FIELDS}.has_slug.choices.false` },
      ]}
    />,
  ]
}

const ServicesList = (): JSX.Element => {
  const translate = useTranslate()
  return (
    <ListBase
      listAction={{
        hasExport: false,
      }}
      filters={ServicesListFilters()}
      sort={{ field: 'create_at', order: 'DESC' }}
    >
      <Datagrid rowClick='edit'>
        <TextField
          source='title_th'
          label={`${SERVICES_FIELDS}.title_th`}
          // sortable={false}
        ></TextField>
        <TextField
          source='title_en'
          label={`${SERVICES_FIELDS}.title_en`}
          // sortable={false}
        ></TextField>
        {/* <TextField
          source='booking_service_key'
          label={`${SERVICES_FIELDS}.booking_service_key`}
          sortable={false}
        ></TextField> */}
        <ReferenceField
          source='booking_service_key'
          reference='mst-services-key'
          label={`${SERVICES_FIELDS}.booking_service_key`}
          // sortable={false}
        >
          <TextField source='title_th' emptyText='-' />
        </ReferenceField>
        <FunctionField
          source='type'
          label={`${SERVICES_FIELDS}.type.label`}
          render={({ type }): string =>
            type === 'n'
              ? translate(`${SERVICES_FIELDS}.type.choices.normal`)
              : translate(`${SERVICES_FIELDS}.type.choices.promotion`)
          }
          // sortable={false}
        />
        <DateField
          source='create_at'
          label={`${COMMON_FIELDS}.date.created_at`}
          textAlign='center'
        />
        <DateField
          source='update_at'
          label={`${COMMON_FIELDS}.date.updated_at`}
          textAlign='center'
        />
        <DateField source='start_date' label={`${SERVICES_FIELDS}.start_date`} textAlign='center' />
        <DateField source='end_date' label={`${SERVICES_FIELDS}.end_date`} textAlign='center' />
      </Datagrid>
    </ListBase>
  )
}

export default ServicesList
